import React, { useState, useRef, useEffect, Fragment, useLayoutEffect } from "react";
import AddEditNotesData from "./ViewNotesData";
import AllNotesShow from "./AllNotesShow";
import { useFetchCustomerNotesColorDataQuery, useFetchCommonDataQuery } from "../../../utils/customer/customerSelect";
import { useNavigate, useParams } from "react-router-dom";
import useRequireAuth from "../../../utils/useRequireAuth";
import { saveNotes } from "../../../utils/customer/customerNotesSlice";
import { useDispatch, useSelector } from "react-redux";
import { CUSTMOER_NOTES_ATTACHMENT_DATA_GET, CUSTOMER_NOTES_ADD_UPDATE } from "../../../utils/constants";
import { deleteData } from "../../store/customer/CustomerSocialAddUpdateFunction";
import {
  useCreateJobMutation,
  useLazyFetchCustomerNotesTableDataQuery,
  useLinkTaskMutation,
  usePostApiMutation,
  usePostNoteAttachmentMutation,
} from "../../../utils/customer/customerTaskTable";
import { pushAlert } from "../../../utils/alertSlice";
import { ReactComponent as Close } from "../../../assets/images/icons/GoBackIcon.svg";
import { ReactComponent as LatestPinUnpin } from "../../../assets/images/icons/LatestPinUnpin.svg";
import { ReactComponent as FillTag } from "../../../assets/images/icons/fillTag.svg";
import { ReactComponent as TiltPin } from "../../../assets/images/icons/PinedSolidIcon.svg";
import { ReactComponent as AddNotesIcon } from "../../../assets/images/icons/PlusIcongrey.svg";
import { ReactComponent as SortingIcon } from "../../../assets/images/icons/Sorting.svg";
import { ReactComponent as SortDecreasing } from "../../../assets/images/SortDec.svg";
import { ReactComponent as SortIncreasing } from "../../../assets/images/SortIncIcon.svg";
import { ReactComponent as RedDecreasing } from "../../../assets/images/icons/RedDecreasing.svg";
import { ReactComponent as RedIncreasing } from "../../../assets/images/icons/RedIncreasing.svg";
import ToolTipComponent from "../../UniversalComponents/ToolTipComponent";
import {
  filterNotesByTags,
  getFormData,
  getHexWithOpacity,
  getUniqueTags,
} from "../../../utils/utilityFunctions/stringUtility";
import { hideLoader, showLoader } from "../../../utils/loaderSlice";
import MotionSearchBox from "../../UniversalComponents/MotionSearchBox";
import { getFormatDate } from "../../../utils/utilityFunctions/dateUtility";
import { getCompanyId, getOrganizationId, getUserData, getUserId } from "../../../utils/utilityFunctions/localServices";
import { linkTasks } from "../../../utils/api/taskApi";
import moment from "moment";
import LoaderWrapper from "../../UniversalComponents/CustomLoader";
import { Dialog } from "@mui/material";
import InternalNavigation from "../../UniversalComponents/InternalNavigation";
import FloatingList from "./../../UniversalComponents/FloatingElement";
import { sort } from "rrule/dist/esm/dateutil";
import { set } from "date-fns";
import { getUserDateTime } from "../../../utils/utilityFunctions/UTCFormat";
import SearchIcon from "../../../assets/images/icons/SearchIcon";
import InternalNavigationRounded from "../../UniversalComponents/InternalNavigationRounded";
import CustomDialog from "../../UniversalComponents/CustomDialog";
// import SearchIcon from "../../../assets/images/icons/SearchIcon.svg";

const DaysToFollowUp = Array.from({ length: 2 }).map((_, idx) => {
  const actualIndex = idx + 1;
  const date = moment().add(actualIndex, "days");
  const formattedDate = date.format("DD MMM");

  const dayLabel = actualIndex === 1 ? "Tomorrow" : "Day After";

  return {
    label: `${dayLabel} (${formattedDate})`,
    value: date.format("DD MMM YYYY HH:mm"), // Store full date for easy comparison
    date: formattedDate,
  };
});

const AddNotes = ({
  type: sectionType = "Tracking",
  subNavitems,
  propTemplateId,
  disableAddMode = false,
  row_id,
  core_id,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const textareaRef = useRef(null);
  const { token } = useRequireAuth();
  const { id: customerId, tab: tabValue } = useParams();
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [viewPinnedNotes, setViewPinnedNotes] = useState({ pinned: "pinned" });
  const [pinnedCount, setPinnedCount] = useState(0);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [sortingView, setSortingView] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [sortBy, setSortBy] = useState(null);
  const [viewNotes, setViewNotes] = useState({
    allnotes: false,
    addnotes: false,
  });
  const [selectedTags, setSelectedTags] = useState([]);
  const companyLocalData = JSON.parse(localStorage.getItem("company_data"));
  const [notetborder, setNoteTborder] = useState(false);
  const [formData, setFormData] = useState({
    notes_title: "",
    notes_category_id: "",
    colour_code: "",
  });
  const [color, setColor] = useState(null);
  const [disable, setDisable] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [tagSearchTerm, setTagSearchTerm] = useState("");
  const containerRef = useRef(null);
  const [page, setPage] = useState(0);
  const notesDatasFormSubmit = useSelector((state) => state.notes);
  const [pinnedNotes, setPinnedNotes] = useState([]);

  const [refetchCustomerData, { data: AllNotesData, isLoading }] = useLazyFetchCustomerNotesTableDataQuery();

  const [
    AddUpdateNotes,
    {
      data: NotesAddUpdateData,
      isError: NotesAddUpdateError,
      isSuccess: NotesAddUpdateSuccess,
      isLoading: NotesAddUpdateLoading,
    },
  ] = usePostApiMutation();

  useEffect(() => {
    if (AllNotesData?.data && AllNotesData?.data?.notes) {
      const pinnedNotesData = AllNotesData?.data?.notes?.filter((note) => note.is_pinned === true) || [];
      setPinnedNotes(pinnedNotesData);
      const count = pinnedNotesData?.length || 0;
      setPinnedCount(count);
    }
  }, [AllNotesData]);

  const handleRefetchNoteData = async () => {
    await refetchCustomerData({
      customerId: customerId ?? core_id,
      page: 1,
      limit: 1000,
      sort: sortBy,
      type: sectionType,
      template_id: propTemplateId,
      row_id: row_id ?? null,
    });
  };

  useEffect(() => {
    handleRefetchNoteData();
  }, [page, token, notesDatasFormSubmit.notes, refreshKey, sectionType, sortBy]);

  useEffect(() => {
    //loading
    if (NotesAddUpdateLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [NotesAddUpdateLoading]);

  const handleNotesClick = () => {
    setViewNotes({ allnotes: true, addnotes: true });
    setDisable(false);
    // setSelectedOptions([]);
  };

  const hndleCloseNotes = () => {
    setViewNotes({ allnotes: false, addnotes: false });
    setDisable(true);
    setSelectedFiles([]);
    setSelectedOptions([]);
  };

  const [
    postNoteAttachment,
    {
      isLoading: postNoteAttachmentLoading,
      isSuccess: postNoteAttachmentSuccess,
      isError: postNoteAttachmentError,
      data: postNoteAttachmentData,
    },
  ] = usePostNoteAttachmentMutation();

  const handleFileUpload = async () => {
    const input = document.createElement("input");
    input.type = "file";
    input.multiple = true;
    input.click();

    input.addEventListener("change", async (event) => {
      const files = Array.from(event.target.files);
      let updatedFiles = [...selectedFiles];
      let lastId = selectedFiles.length > 0 ? selectedFiles[selectedFiles.length - 1].id : 0;

      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const formData = new FormData();
        formData.append("file", file);

        try {
          const response = await postNoteAttachment({ data: formData }).unwrap();

          updatedFiles.push({
            id: response.id,
            attachment: response.filename,
            file: file,
            view_url: response.view_url,
            download_url: response.download_url,
            // uploaded_id: response.id, // optional if you want to track server id
          });
        } catch (error) {
          console.error("File upload failed for:", file.name, error);
        }
      }

      setSelectedFiles(updatedFiles);
    });

    return false;
  };

  const getFileLastName = (filePath) => {
    if (typeof filePath === "string" && filePath.includes("/")) {
      return filePath.split("/").pop();
    } else {
      return filePath;
    }
  };

  const { data: customerTaskCategory, error, isLoading: commonDataLoading } = useFetchCommonDataQuery();

  const { data: customerColor } = useFetchCustomerNotesColorDataQuery({
    token,
  });

  const [isCreateTask, setIsCreateTask] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedContent, setSelectedContent] = useState("Task");
  const [selectedDate, setSelectedDate] = useState(DaysToFollowUp[0].value);
  const [selectedList, setSelectedList] = useState([]);
  const [mentions, setMentions] = useState([]); // array of strings (emails or uuids)

  const handleInputChange = ({ target: { name, value } }) => setFormData({ ...formData, [name]: value });
  const handleSetColour = (colour) => setColor(colour);

  const [createTaskApi, { data: taskData, isFetching: isTaskDataFetching }] = useCreateJobMutation();
  const [LinkNoteToTask, { data: linkTaskData, isFetching: isLinkTaskDataFetching }] = useLinkTaskMutation();

  const handleLinkTo = async (taskId, noteId) => {
    try {
      const body = {
        company_id: getCompanyId(),
        org_id: getOrganizationId(),
        parent: "TASK",
        parent_id: taskId,
        child: "NOTES",
        child_ids: [noteId],
      };
      const response = await linkTasks({ body });
      if (response?.success) {
      } else {
        throw new Error(response?.message);
      }
    } catch (error) {
      dispatch(pushAlert({ type: "danger", message: error.message || "Something went wrong.", visible: true }));
      console.log(error?.message || "Something went wrong.");
    } finally {
      // setLoading(false);
      // fetchResources();
    }
  };

  const handleCreateTask = async (noteData) => {
    const user = getUserData();
    console.log("usernoteData", noteData);

    const payload = {
      data: {
        id: null,
        customer_name: "",
        customer_id: customerId ?? core_id,
        customer_display_name: null,
        remarks: null,
        subject: noteData.notes_title || "",
        category_id: selectedContent,
        description: null,
        status: "Not started",
        start_date: selectedDate,
        end_date: selectedDate,
        start_time: "",
        end_time: "",
        assigned_to: [
          {
            id: user.user_id || getUserId(),
            uuid: user.user_uuid || "",
            name: user.name || "",
            email: user.email || "",
          },
        ],
        is_recurrence: null,
        recurrence_pattern_id: null,
        radioselected: "every_weekday",
        after_occur: null,
        frequency: "daily",
        intervals: 1,
        every_weeks: null,
        daily_recur: null,
        monthly_recur: null,
        yearly_recur: null,
        occurrences: null,
        daily_option: null,
        every_n_days: null,
        weekly_days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        endBy: null,
        end_by: null,
        monthly_option: null,
        specific_day: null,
        monthly_week: "first",
        yearly_option: null,
        specific_year: null,
        sub_tasks: [],
        checklists: [],
        company_id: getCompanyId(),
        billing_details: [{}],
      },
      template_id: "01c04298-9231-11f0-b592-bc2411f4d589",
      notes_id: noteData?.id,
    };
    const response = await LinkNoteToTask({ payload: payload }).unwrap();
    if (response?.success) {
      dispatch(pushAlert({ message: response?.message, type: "success", visible: true }));
      // handleLinkTo(response.data.task_id, noteData.note_id ? noteData.note_id : noteData.id);
    } else {
      dispatch(pushAlert({ message: response?.message, type: "danger", visible: true }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const notesData = {
      notes_category_id: formData.notes_category_id || 1,
      colour_code: color ?? "#008937",
      notes_title: formData.notes_title,
      company_id: companyLocalData.company_id,
      customer_id: customerId ?? core_id,
      notes_body: textareaRef.current.innerHTML,
      rag_status: "wip",
      // attachment: selectedFiles,
      is_pinned: false,
      attachmentIds: selectedFiles.map((file) => file.id),
      tags: selectedOptions,
    };

    // only include properties when mentions has items
    if (Array.isArray(mentions) && mentions.length > 0) {
      notesData.properties = { mentions: mentions };
    }

    if (
      textareaRef.current.innerHTML !== "<br>" &&
      textareaRef.current.innerHTML !== ""
      // formData.notes_title !== ""
    ) {
      try {
        const response = await AddUpdateNotes({
          data: notesData,
          url: `${CUSTOMER_NOTES_ADD_UPDATE}?${propTemplateId ? `template_id=${propTemplateId}` : `type=${sectionType}`}`,
        });

        if (response?.success || response?.data?.success || response?.data?.status) {
          dispatch(
            pushAlert({
              message: "Note added successfully.",
              type: "success",
              visible: true,
            })
          );
          console.log("Note added successfully:", response.data.data);
          // Reset form and update UI

          setFormData({ notes_title: "", notes_category_id: "", colour_code: "" });
          handleRefetchNoteData();
          setRefreshKey((prevKey) => prevKey + 1);
          setViewNotes({ allnotes: false, addnotes: false });
          setDisable(true);
          setSelectedFiles([]);
          setSelectedOptions([]);
          if (isCreateTask) handleCreateTask(response.data.data); // Call to create task if needed
        } else {
          dispatch(
            pushAlert({
              message: "Failed to update notes",
              type: "danger",
              visible: true,
            })
          );
        }
      } catch (error) {
        dispatch(hideLoader());
        dispatch(
          pushAlert({
            message: error.message || "Something went wrong",
            type: "danger",
            visible: true,
          })
        );
      }
    } else {
      if (formData.notes_title === "") {
        dispatch(
          pushAlert({
            message: "Notes title cannot be blank.",
            type: "danger",
            visible: true,
          })
        );
      }
      if (textareaRef.current.innerHTML === "<br>" || textareaRef.current.innerHTML === "") {
        dispatch(
          pushAlert({
            message: "Notes body cannot be blank.",
            type: "danger",
            visible: true,
          })
        );
      }
      setNoteTborder(true);
    }
  };

  const handleDeleteFileServer = async (id, editNoteId) => {
    const url = `${CUSTMOER_NOTES_ATTACHMENT_DATA_GET}${id}`;
    try {
      const newSelectedFiles = selectedFiles.filter((f) => f.id !== id);
      resetFile(newSelectedFiles);

      const response = await deleteData(url, token);
      if (response?.success || response?.data?.success || response?.data?.status) {
        setViewNotes({ allnotes: true, addnotes: true });
        dispatch(pushAlert({ message: "File deleted successfully.", type: "success", visible: true }));
      } else {
        dispatch(pushAlert({ message: "File not deleted successfully.", type: "danger", visible: true }));
      }
    } catch (error) {
      dispatch(pushAlert({ message: "Something went wrong", type: "danger", visible: true }));
      console.error("Error deleting file:", error);
    }
  };

  const highlightTextInHtml = (html, highlight) => {
    if (!highlight.trim()) return html;

    const regex = new RegExp(`(${highlight})`, "gi");
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    const walker = document.createTreeWalker(tempDiv, NodeFilter.SHOW_TEXT, null, false);
    let node;
    while ((node = walker.nextNode())) {
      const text = node.textContent;
      if (regex.test(text)) {
        const span = document.createElement("span");
        span.innerHTML = text.replace(regex, (match) => `<span class="bg-yellow-300">${match}</span>`);
        node.replaceWith(span);
      }
    }

    return tempDiv.innerHTML;
  };

  const resetFile = (newSelectedFiles) => setSelectedFiles(newSelectedFiles ?? []);

  const handleClickDeleteFile = (id) => {
    if (id >= 0 && id < selectedFiles.length) {
      resetFile(selectedFiles.filter((file, idx) => idx !== id));
    }
  };

  const handleCheckboxChange = (tag, isChecked) => {
    if (isChecked) {
      setSelectedTags((prev) => [...prev, tag]);
    } else {
      setSelectedTags((prev) => prev.filter((t) => t !== tag));
    }
  };

  const handlePinClick = (type) => {
    setViewPinnedNotes((prev) => ({ ...prev, pinned: type }));
  };

  const handleClickScroll = (note) => {
    const noteElement = document.getElementById(`note-${note.id}`);
    if (noteElement) {
      const originalClasses = [...noteElement.classList];

      noteElement.scrollIntoView({ behavior: "smooth", block: "center" });

      noteElement.classList.add("animate-zoom-in", "border-2", "border-[#50C878]", "highlight-transition");

      setTimeout(() => {
        noteElement.classList.remove("animate-zoom-in", "border-2", "border-[#50C878]", "highlight-transition");

        originalClasses.forEach((className) => {
          if (!noteElement.classList.contains(className)) {
            noteElement.classList.add(className);
          }
        });

        noteElement.classList.add("transition-all", "duration-600");
      }, 2000);
    }
  };

  const handlePinned = async (note) => {
    const notesData = {
      notes_category_id: note.notes_category_id,
      colour_code: color ?? note.colour_code,
      notes_title: note.notes_title,
      company_id: companyLocalData.company_id,
      customer_id: customerId ?? core_id,
      notes_body: note.notes_body,
      rag_status: "wip",
      id: note.id,
      tags: note.tags,
      is_pinned: !Boolean(note.is_pinned),
    };

    const PinUnpinNote = getFormData(notesData);

    try {
      const response = await AddUpdateNotes({
        data: notesData,
        url: `${CUSTOMER_NOTES_ADD_UPDATE}?${propTemplateId ? `template_id=${propTemplateId}` : `type=${sectionType}`}`,
      });

      // Handle success
      if (response?.success || response?.data?.success || response?.data?.status) {
        dispatch(
          pushAlert({
            message: !Boolean(note.is_pinned) ? "Note pinned successfully." : "Note unpinned successfully.",
            type: "success",
            visible: true,
          })
        );

        handleRefetchNoteData();
        // setRefreshKey((prevKey) => prevKey + 1);
      } else {
        dispatch(
          pushAlert({
            message: response.data?.message || "Failed to update pin status",
            type: "danger",
            visible: true,
          })
        );
      }
    } catch (error) {
      dispatch(hideLoader());
      dispatch(
        pushAlert({
          message: error.message || "Error updating pin status",
          type: "danger",
          visible: true,
        })
      );
    }
  };

  const [showLoaderInBox, setShowLoaderInBox] = useState(false);

  useEffect(() => {
    if (isLoading) {
      if (AllNotesData?.data) dispatch(showLoader());
      else setShowLoaderInBox(true);
    } else {
      dispatch(hideLoader());
      setShowLoaderInBox(false);
    }
  }, [isLoading]);

  const PararagraphComponentForPinnedNote = ({ CategoryData, searchTerm }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [showReadMore, setShowReadMore] = useState(false);
    const paragraphRef = useRef(null);

    useLayoutEffect(() => {
      const checkHeight = () => {
        if (paragraphRef.current) {
          const { scrollHeight, clientHeight } = paragraphRef.current;

          setShowReadMore(scrollHeight > clientHeight);
        }
      };

      checkHeight();
    }, [CategoryData]);

    const handleReadMoreClick = (e) => {
      e.stopPropagation();
      setIsExpanded(!isExpanded);
    };

    return (
      <div className="space-y-1 pr-7 w-full">
        <p
          ref={paragraphRef}
          className={`text-[11px] text-wrap font-normal text-justify text-[#666] w-full break-words ${
            isExpanded ? " " : "line-clamp-1"
          }`}
          dangerouslySetInnerHTML={{
            __html: highlightTextInHtml(CategoryData, searchTerm),
          }}
        ></p>

        {showReadMore && (
          <button
            className="text-blue-500 hover:text-blue-600 font-300 text-xs cursor-pointer"
            onClick={(e) => handleReadMoreClick(e)}
          >
            {isExpanded ? "Read less" : "Read more"}
          </button>
        )}
      </div>
    );
  };
  // Helper to convert hex to rgba
  function hexToRgba(hex, alpha = 0.4) {
    let c = hex.replace("#", "");
    if (c.length === 3)
      c = c
        .split("")
        .map((x) => x + x)
        .join("");
    const num = parseInt(c, 16);
    return `rgba(${(num >> 16) & 255}, ${(num >> 8) & 255}, ${num & 255}, ${alpha})`;
  }

  console.log("selectedDate tagss", selectedTags, AllNotesData?.data);
  console.log(viewNotes.addnotes, "viewNotes4685456");

  const handleSort = (value) => {
    if (value) {
      setSortBy(value);
    }
  };

  return (
    <div className={`flex gap-2 w-full h-full`}>
      <div className={` flex flex-col grow min-w-0  gap-2`}>
        {/* header */}
        <div className="flex items-center justify-between  sticky top-0 bg-white z-10  border[#E9E9E9]">
          {subNavitems?.length ? <InternalNavigation items={subNavitems} subTabValue={"notes"} /> : <h3>All Notes</h3>}
          <div className="flex gap-x-2 mx-2">
            {/* <div
                className={` w-fit flex items-center justify-center ${!isSearchOpen && " rounded-md pr-2 bg-[#CECECE4D] border border-[#CECECE4D] hover:bg-[#B1B1B14D] hover:border-[#D2DAE1] text-[#8E8E8E] hover:text-[#505E70]"}`}
              >
                <MotionSearchBox
                  isSearchActive={isSearchOpen}
                  setIsSearchActive={setIsSearchOpen}
                  searchText={searchTerm}
                  setSearchText={setSearchTerm}
                  placeholder={"Search For Notes..."}
                  ClassName={"h-[28px] bg-[#fff] border text-[#767676cc] border-[#D2DAE1] text-sm font-normal"}
                  expanded
                />
              </div> */}
            <div
              className={`relative w-fit flex items-center justify-center ${
                !isSearchOpen && "rounded-md bg-[#CECECE4D]  text-[#8E8E8E] hover:text-[#505E70]"
              }`}
            >
              {/* Search input (visible when search is active) */}
              {isSearchOpen && (
                <input
                  type="text"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  placeholder="Search For Notes..."
                  // className="h-[28px] w-[220px] bg-white border text-[#767676cc]  text-sm font-normal px-2 border-prim rounded-md outline-none transition-all duration-200 ring-0 focus:ring-0 focus-r"
                  className="h-[28px] w-[220px] bg-white border border-[#D1D1D1] text-[#767676cc] text-sm font-normal px-2 rounded-md outline-none transition-all duration-200 focus:border-primary focus:ring-0"
                />
              )}

              {/* Search icon (universal component) */}
              <div className="absolute right-0 top-1/2 transform -translate-y-1/2 text-gray-500 cursor-pointer">
                <ToolTipComponent darkMode text="Search">
                  <span onClick={() => setIsSearchOpen(!isSearchOpen)} className="cursor-pointer rounded-full p-1">
                    <SearchIcon isHovered={isHovered} isActive={isSearchOpen} />
                  </span>
                </ToolTipComponent>
              </div>
            </div>

            <div className="flex items-center gap-x-2">
              {/* search */}
              <div
                className="relative"
                onMouseEnter={() => setSortingView(true)}
                onMouseLeave={() => setSortingView(false)}
              >
                <ToolTipComponent darkMode text={"Sort"}>
                  <div className="p-2 group rounded-md cursor-pointer bg-[#CECECE4D] border border-[#CECECE4D] hover:bg-[#B1B1B14D] hover:border-[#D2DAE1]">
                    {(sortBy === "asc" && (
                      <RedIncreasing onClick={() => setSortBy(null)} className="w-4 h-4 shrink-0" />
                    )) ||
                      (sortBy === "desc" && (
                        <RedDecreasing onClick={() => setSortBy(null)} className="w-4 h-4 shrink-0" />
                      )) || <SortingIcon className="fill-[#8E8E8E] group-hover:fill-[#505E70]" />}
                  </div>
                </ToolTipComponent>

                {sortingView && (
                  <div className="absolute top-full">
                    <FloatingList xPadding={1} yMargin={1} xMargin={-10}>
                      <div className="bg-white border rounded-md">
                        <ul>
                          <li
                            className="p-2 hover:bg-gray-100 cursor-pointer text-[#778FA5] flex items-center gap-1 text-[12px]"
                            onClick={() => handleSort("asc")}
                          >
                            <SortIncreasing className="w-4 h-4 shrink-0 fill-[#778FA5]" />
                            newest to Oldest
                          </li>

                          <li
                            className="p-2 hover:bg-gray-100 cursor-pointer text-[#778FA5] flex items-center gap-1 text-[12px]"
                            onClick={() => {
                              handleSort("desc");
                              setSortingView(false);
                            }}
                          >
                            <SortDecreasing className="w-4 h-4 shrink-0 fill-[#778FA5]" />
                            Oldest to newest
                          </li>
                        </ul>
                      </div>
                    </FloatingList>
                  </div>
                )}
              </div>
              {/* tag */}
              <ToolTipComponent darkMode text={"Filters By Tags"}>
                <button
                  className={`h-8 px-2.5  group text-sm font-medium rounded flex items-center
                    ${viewPinnedNotes.pinned === "tags" ? "bg-primary fill- " : "bg-[#CECECE4D] hover:bg-primary-active "}
                  `}
                  onClick={() => handlePinClick("tags")}
                >
                  <FillTag
                    className={`transition-colors
                        ${viewPinnedNotes.pinned === "tags" ? "fill-white" : "fill-[#8E8E8E] group-hover:fill-primary"}
                      `}
                  />
                </button>
              </ToolTipComponent>

              {/* pinning button */}

              <ToolTipComponent darkMode text={"View Pinned Notes"}>
                <button
                  className={`h-8 px-2.5 border gap-x-2 group text-sm font-medium rounded flex items-center
                    ${
                      viewPinnedNotes.pinned === "pinned"
                        ? "bg-primary border-primary text-white"
                        : "bg-[#CECECE4D] border-[#CECECE4D] hover:bg-primary-active hover:border-primary text-[#8E8E8E] hover:text-[#505E70]"
                    }
                  `}
                  onClick={() => handlePinClick("pinned")}
                >
                  <LatestPinUnpin
                    className={`fill-[#8E8E8E] group-hover:fill-[#505E70] ${viewPinnedNotes.pinned === "pinned" && "fill-[#FFFFFF] group-hover:fill-[#FFFFFF]"}`}
                  />
                  ({pinnedCount})
                </button>
              </ToolTipComponent>

              {!disableAddMode && <div className="border-r-2 border-[#D2DAE1] h-7 w-0"></div>}

              {/* Add Notes Button */}
              {!disableAddMode && (
                <ToolTipComponent darkMode text={"Add Notes"}>
                  <button
                    className={`h-8 px-2.5  ${
                      viewNotes?.addnotes === true
                        ? "bg-primary text-white"
                        : "bg-[#CECECE4D]  hover:bg-primary-active  text-[#8E8E8E] hover:text-[#505E70]"
                    } text-sm font-400 rounded whitespace-nowrap`}
                    onClick={handleNotesClick}
                  >
                    <AddNotesIcon
                      className={`fill-[#8E8E8E] group-hover:fill-[#505E70] ${viewNotes?.addnotes === true && "fill-[#FFFFFF]"}`}
                    />
                  </button>
                </ToolTipComponent>
              )}
            </div>
          </div>
        </div>
        <div className="flex flex-col grow min-h-0">
          {/* add the note */}
          <div className={`notes ${Object.values(viewNotes).some((value) => value) ? "show" : ""}`}>
            <Dialog open={viewNotes.addnotes} onClose={hndleCloseNotes} fullWidth maxWidth="md">
              <AddEditNotesData
                key={refreshKey}
                setNotesSetting={() => {}}
                notesSetting={false}
                handleNotesClick={handleNotesClick}
                textareaRef={textareaRef}
                visible={viewNotes.addnotes}
                selectedFile={selectedFiles}
                resetFile={resetFile}
                notetborder={notetborder}
                customerTaskCategory={customerTaskCategory}
                customerColor={customerColor}
                handleSubmit={handleSubmit}
                handleInputChange={handleInputChange}
                formData={formData}
                handleSetColour={handleSetColour}
                refreshKey={setRefreshKey}
                initialContent={""}
                setInitialContent={() => {}}
                handleFileUpload={handleFileUpload}
                hndleCloseNotes={hndleCloseNotes}
                handleClickDeleteFile={handleClickDeleteFile}
                getFileLastName={getFileLastName}
                handleDeleteFileServer={handleDeleteFileServer}
                selectedOptions={selectedOptions}
                setSelectedOptions={setSelectedOptions}
                selectedContent={selectedContent}
                setSelectedContent={setSelectedContent}
                selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
                isCreateTask={isCreateTask}
                setIsCreateTask={setIsCreateTask}
                DaysToFollowUp={DaysToFollowUp}
                mentions={mentions}
                setMentions={setMentions}
              />
            </Dialog>
          </div>

          <div className="h-full overflow-auto thinscrollbar bg-[#FFF] mujeeb">
            {/* <LoaderWrapper isLoading={showLoaderInBox}>          */}
            <div className="min-w-0 h-full grow thinscrollbar pr-1" ref={containerRef}>
              {/* main notes render front page */}
              <AllNotesShow
                disable={disable}
                refreshKey={setRefreshKey}
                key={refreshKey}
                customerColor={customerColor}
                searchTerm={searchTerm}
                handlePinned={handlePinned}
                fetchedNotesData={filterNotesByTags(AllNotesData?.data, selectedTags)}
                RefetchNoteData={handleRefetchNoteData}
                selectedOptions={selectedOptions}
                setSelectedOptions={setSelectedOptions}
                sectionType={sectionType}
                selectedContent={selectedContent}
                setSelectedContent={setSelectedContent}
                selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
                selectedList={selectedList}
                setSelectedList={setSelectedList}
                DaysToFollowUp={DaysToFollowUp}
                isCreateTask={isCreateTask}
                setIsCreateTask={setIsCreateTask}
                handleCreateTask={handleCreateTask}
                showLoaderInBox={showLoaderInBox}
                propTemplateId={propTemplateId}
                handleAddNotesClick={handleNotesClick}
                disableAddMode={disableAddMode}
              />
            </div>
            {/* </LoaderWrapper> */}
          </div>
        </div>
      </div>

      {/* pin notes */}
      {viewPinnedNotes.pinned === "pinned" && (
        <div className="min-w-[25%] w-[25%] bg-[#F8FBFF] flex flex-col   rounded-lg">
          <div className="w-full ">
            <div className="flex gap-3 items-center sticky top-0 bg-[#F8FBFF] z-10 px-3 border-b border-[#BECBD3] py-3">
              <Close className="cursor-pointer text-primary hover:text-gray-700" onClick={handlePinClick} />
              <h5 className="font-medium text-primary flex items-center text-base">
                <TiltPin className="mr-2" /> Pinned Notes ({pinnedCount})
              </h5>
            </div>
          </div>

          {/* Scrollable Pinned Notes */}
          <div className="grow min-h-0 overflow-x-hidden invisible-scrollbar">
            {pinnedNotes.map((note, idx) => (
              <div className="group">
                <div
                  className="my-2 mx-1 py-1 hover:bg-[#dae4ff78] rounded-md"
                  key={note.id}
                  onClick={() => handleClickScroll(note)}
                >
                  <div className="flex items-start justify-between">
                    <div className="flex flex-col items-start justify-evenly grow min-w-0 px-3">
                      <div className="flex items-center justify-between pb-2 w-full gap-x-2">
                        {/* Note Details */}
                        <div className="flex flex-col items-start justify-center min-w-0 grow">
                          <div
                            className="text-[#1D4469] text-base font-medium capitalize w-full truncate"
                            style={{ color: note?.colour_code }}
                            dangerouslySetInnerHTML={{
                              __html: highlightTextInHtml(note.notes_title, searchTerm),
                            }}
                          />
                          <div className="flex items-center w-full">
                            <span className="text-[#767676] text-[9px] font-normal capitalize">{note.created_by}</span>
                            <span className="bg-[#D2DAE1] w-[1px] h-3 mx-1"></span>
                            <span className="text-[#767676] text-[9px] font-normal capitalize">
                              {getUserDateTime(note.created_at)}
                            </span>
                          </div>
                        </div>

                        {/* Actions */}
                        <div className="flex items-center gap-x-2 opacity-0 transition-opacity duration-200 group-hover:opacity-100">
                          <span onClick={() => handlePinned(note)} className="w-[15px] group/pin">
                            <ToolTipComponent text={"Unpin"} placement="left">
                              <LatestPinUnpin
                                className={`cursor-pointer ${
                                  Boolean(note?.is_pinned)
                                    ? "fill-[#00BA00] group-hover/pin:fill-[#30a930]"
                                    : "fill-[#8E8E8E] group-hover/pin:fill-black"
                                }`}
                              />
                            </ToolTipComponent>
                          </span>
                        </div>
                      </div>

                      <PararagraphComponentForPinnedNote
                        CategoryData={note.notes_body}
                        searchTerm={searchTerm}
                        className="mt-2"
                      />
                    </div>
                  </div>
                </div>

                {/* Dashed border */}
                <div className="border-b border-dashed border-[#1d446952] mx-4 transition-opacity duration-300 group-hover:opacity-0"></div>
              </div>
            ))}
          </div>
        </div>
      )}
      {viewPinnedNotes.pinned === "tags" && (
        <div className="min-w-[25%] w-[25%] bg-[#F8FBFF] flex flex-col  rounded-lg">
          <div className="w-full">
            <div className="flex gap-3 items-center sticky top-0 bg-[#F8FBFF] z-10 px-3 border-b border-[#BECBD3] py-3">
              <div className="">
                <Close className="cursor-pointer text-gray-500 hover:text-gray-700" onClick={handlePinClick} />
              </div>
              <h5 className="font-medium text-primary flex items-center text-base">Tags List</h5>
            </div>
          </div>

          {/* Search Box */}
          {/* <div className="flex items-center justify-between gap-x-2 mb-2">
              <MotionSearchBox
                searchText={tagSearchTerm}
                setSearchText={setTagSearchTerm}
                placeholder={"Search For Notes..."}
                expanded
                ClassName={"h-[35px]"}
              />
            </div> */}

          {/* Scrollable Tag List */}
          <div className="flex-1 min-h-0 overflow-y-auto thinscrollbar">
            <div className="flex flex-col items-start gap-y-2 p-5">
              {getUniqueTags(AllNotesData?.data).map((tag, index) => (
                <div key={index} className="flex items-center gap-x-2">
                  <input
                    type="checkbox"
                    id="tag-123"
                    className={`mr-2 focus:outline-none focus:ring-0 rounded-sm border-[#D9D9D9]`}
                    checked={selectedTags.includes(tag)}
                    onChange={(e) => handleCheckboxChange(tag, e.target.checked)}
                  />
                  <p
                    className="text-sm text-white max-w-[30vw] py-1 px-2 rounded-md font-normal"
                    style={{
                      backgroundColor: getHexWithOpacity(tag?.color_code, 10) || "#666",
                      color: tag?.color_code,
                      border: `1px solid ${tag?.color_code}`,
                    }}
                    dangerouslySetInnerHTML={{
                      __html: highlightTextInHtml(tag?.label, tagSearchTerm),
                    }}
                  ></p>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddNotes;
